import React from 'react'
interface MapContextValue {
    latlng: any,
    setLatlng: Function,
}
//const Context = React.createContext<MapContextValue | null>(null)
const Context = React.createContext({} as MapContextValue)
export default Context
